import { ReactNode, useState } from 'react';
import { Box, Text } from 'theme-ui';

interface TooltipProps {
  content: string;
  children: ReactNode;
}

const Tooltip = ({ content, children }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Box
      sx={{ position: 'relative' }}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      aria-label={content}
    >
      {children}
      {isVisible && (
        <Text sx={{ fontSize: 2, display: ['none', 'block'], position: 'absolute', bottom: 'calc(100% + 10px)', left: '50%', transform: 'translateX(-50%)' , bg: 'black', p: 4, whiteSpace: 'nowrap', maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis' , borderRadius: 2, color: 'white' }} aria-hidden>
          {content}
        </Text>
      )}
    </Box>
  );
};

export default Tooltip;
